<div class="breadcrumb-main">
    <div class="breadcrumb-selected">
        <div class="member-icon"></div>
        <div id="breadcrumb-family" class="breadcrumb-selected-name" *ngIf="!isBothDisplayNamesNull">{{selectedFamily?.displayName}}</div>
    </div>
</div>